import { Typography } from '@mui/material';
import { Login as RaLogin, useLogin, Button } from 'react-admin';
import LoginIcon from '@mui/icons-material/Login';

export const Login = () => {
    const login = useLogin();
    const handleClick = () => {
        login({});
    }
    return (
        <RaLogin sx={{ background: 'none' }}>
            <Typography
                sx={{
                    color: 'text.disabled',
                    textAlign: 'center',
                }}
            >
                <Button label="Log in" onClick={handleClick}>
                    <LoginIcon />
                </Button>
            </Typography>

        </RaLogin>
    )
}
